import IndexPage from "../indexPage"
import WrapPage from "../components/wrapPage"

export default WrapPage(IndexPage)
